(function () {
  'use strict';

  angular.module('app').component('receivedPaymentsPage', receivedPaymentListCtrl());

  function receivedPaymentListCtrl() {
    return {
      bindings: {},
      controller: ReceivedPaymentListCtrl,
      controllerAs: 'vm',
      templateUrl: './app/ajs/received-payments/received-payments-page.component.html',
    };
  }

  ReceivedPaymentListCtrl.$inject = [
    '$location',
    'UtilService',
    'AbilityService',
    'SessionService',
    'ReceivedPaymentService',

    // Angular downgraded service
    'companyService',
  ];

  function ReceivedPaymentListCtrl(
    $location,
    UtilService,
    AbilityService,
    SessionService,
    ReceivedPaymentService,

    // Angular downgraded service
    companyService
  ) {
    const vm = this;

    vm.UtilService = new UtilService(vm);

    vm.filterCriteria = ReceivedPaymentService.getFilterCriteria();

    vm.filterCriteria.by_date_from = vm.UtilService.startOfDayFormat(vm.UtilService.startOfMonth());
    vm.filterCriteria.by_date_to = vm.UtilService.endOfDayFormat(vm.UtilService.today());

    vm.permissions = {
      canCreate: AbilityService.can('create_receivedpayment_accountadmin'),
    };

    // Methods
    vm.createItem = createItem;
    vm.onShowItem = onShowItem;

    // Initializers
    getReceivedPayments();
    getCompany();

    function getReceivedPayments() {
      vm.loadingItems = true;
      ReceivedPaymentService.getReceivedPayments(vm.filterCriteria).then(function (data) {
        vm.items = data.items;
        vm.meta = data.meta;

        vm.totalItems = vm.meta.totalItems;

        vm.loadingItems = false;
      });
    }

    function getCompany() {
      const companyId = SessionService.getSelectedAccountCompany().id;

      companyService.getCompany(companyId, { skip_check_role: true }).subscribe((response) => {
        vm.paymentMethods = response.payment_methods.filter((method) => method.status == true);
      });
    }

    function createItem() {
      $location.path('/received_payments/new');
    }

    function onShowItem(item, mode) {
      $location.path(`/received_payments/${item.id}`).search({ mode: mode });
    }
  }
})();
